import { render, staticRenderFns } from "./taskDetailinsup.vue?vue&type=template&id=16a7d99b&scoped=true&"
import script from "./taskDetailinsup.vue?vue&type=script&lang=js&"
export * from "./taskDetailinsup.vue?vue&type=script&lang=js&"
import style0 from "./taskDetailinsup.vue?vue&type=style&index=0&id=16a7d99b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7d99b",
  null
  
)

export default component.exports